export default __webpack_public_path__ + "static/media/logo.d80bbe6b.png";